"use strict";
// DEPRECATED: This file is replaced by firebaseManager.ts
// Keeping for backward compatibility during migration
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeCollectionOperation = exports.deleteField = exports.startAfter = exports.writeBatch = exports.onSnapshot = exports.orderBy = exports.limit = exports.increment = exports.addDoc = exports.deleteDoc = exports.Timestamp = exports.serverTimestamp = exports.getDocs = exports.where = exports.query = exports.collection = exports.arrayRemove = exports.arrayUnion = exports.updateDoc = exports.getDoc = exports.setDoc = exports.doc = exports.getGoogleProvider = exports.getFirebaseApp = exports.getFirebaseAnalytics = exports.getFirebaseFunctions = exports.getFirebaseStorage = exports.isFirebaseInitialized = exports.getFirebaseAuth = exports.getDb = void 0;
var firebaseManager_1 = require("./firebaseManager");
Object.defineProperty(exports, "getDb", { enumerable: true, get: function () { return firebaseManager_1.getDb; } });
Object.defineProperty(exports, "getFirebaseAuth", { enumerable: true, get: function () { return firebaseManager_1.getFirebaseAuth; } });
Object.defineProperty(exports, "isFirebaseInitialized", { enumerable: true, get: function () { return firebaseManager_1.isFirebaseInitialized; } });
Object.defineProperty(exports, "getFirebaseStorage", { enumerable: true, get: function () { return firebaseManager_1.getFirebaseStorage; } });
Object.defineProperty(exports, "getFirebaseFunctions", { enumerable: true, get: function () { return firebaseManager_1.getFirebaseFunctions; } });
Object.defineProperty(exports, "getFirebaseAnalytics", { enumerable: true, get: function () { return firebaseManager_1.getFirebaseAnalytics; } });
Object.defineProperty(exports, "getFirebaseApp", { enumerable: true, get: function () { return firebaseManager_1.getFirebaseApp; } });
Object.defineProperty(exports, "getGoogleProvider", { enumerable: true, get: function () { return firebaseManager_1.getGoogleProvider; } });
// Re-export Firebase functions and types
// IMPORTANT: Avoid using these direct web SDK functions in shared services.
// Instead, use unifiedFirestoreService (unifiedCollection, unifiedGetDoc, etc.)
// to ensure cross-platform compatibility on native iOS/Android platforms.
var firestore_1 = require("firebase/firestore");
Object.defineProperty(exports, "doc", { enumerable: true, get: function () { return firestore_1.doc; } });
Object.defineProperty(exports, "setDoc", { enumerable: true, get: function () { return firestore_1.setDoc; } });
Object.defineProperty(exports, "getDoc", { enumerable: true, get: function () { return firestore_1.getDoc; } });
Object.defineProperty(exports, "updateDoc", { enumerable: true, get: function () { return firestore_1.updateDoc; } });
Object.defineProperty(exports, "arrayUnion", { enumerable: true, get: function () { return firestore_1.arrayUnion; } });
Object.defineProperty(exports, "arrayRemove", { enumerable: true, get: function () { return firestore_1.arrayRemove; } });
Object.defineProperty(exports, "collection", { enumerable: true, get: function () { return firestore_1.collection; } });
Object.defineProperty(exports, "query", { enumerable: true, get: function () { return firestore_1.query; } });
Object.defineProperty(exports, "where", { enumerable: true, get: function () { return firestore_1.where; } });
Object.defineProperty(exports, "getDocs", { enumerable: true, get: function () { return firestore_1.getDocs; } });
Object.defineProperty(exports, "serverTimestamp", { enumerable: true, get: function () { return firestore_1.serverTimestamp; } });
Object.defineProperty(exports, "Timestamp", { enumerable: true, get: function () { return firestore_1.Timestamp; } });
Object.defineProperty(exports, "deleteDoc", { enumerable: true, get: function () { return firestore_1.deleteDoc; } });
Object.defineProperty(exports, "addDoc", { enumerable: true, get: function () { return firestore_1.addDoc; } });
Object.defineProperty(exports, "increment", { enumerable: true, get: function () { return firestore_1.increment; } });
Object.defineProperty(exports, "limit", { enumerable: true, get: function () { return firestore_1.limit; } });
Object.defineProperty(exports, "orderBy", { enumerable: true, get: function () { return firestore_1.orderBy; } });
Object.defineProperty(exports, "onSnapshot", { enumerable: true, get: function () { return firestore_1.onSnapshot; } });
Object.defineProperty(exports, "writeBatch", { enumerable: true, get: function () { return firestore_1.writeBatch; } });
Object.defineProperty(exports, "startAfter", { enumerable: true, get: function () { return firestore_1.startAfter; } });
Object.defineProperty(exports, "deleteField", { enumerable: true, get: function () { return firestore_1.deleteField; } });
/**
 * Safe wrapper for any Firebase collection operation
 * Now uses async Firebase manager for proper initialization
 */
const safeCollectionOperation = (operation, operationName) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Wait for Firebase to be initialized
        const { firebaseManager } = yield Promise.resolve().then(() => __importStar(require('./firebaseManager')));
        yield firebaseManager.initialize();
        if (!firebaseManager.isReady()) {
            const errorMsg = `Firebase not initialized yet for ${operationName}`;
            console.error(`❌ ${errorMsg}`);
            const enhancedError = new Error(errorMsg);
            enhancedError.name = 'FirebaseNotInitializedError';
            throw enhancedError;
        }
        return yield operation();
    }
    catch (error) {
        // Enhanced error logging with more context
        const errorDetails = {
            operationName,
            errorType: error instanceof Error ? error.constructor.name : typeof error,
            errorMessage: error instanceof Error ? error.message : String(error)
        };
        console.error(`❌ Failed to execute ${operationName}:`, error);
        console.error(`❌ Operation context:`, errorDetails);
        // Re-throw with enhanced context for debugging
        if (error instanceof Error) {
            error.message = `${operationName}: ${error.message}`;
        }
        throw error;
    }
});
exports.safeCollectionOperation = safeCollectionOperation;
